import { m } from "framer-motion";
import { Euro, Shield, Wrench, Award, Truck, Headphones } from "lucide-react";
import { useTranslation } from "react-i18next";
import { optimizedViewport } from "@/lib/motion";

const featureKeys = [
  { icon: Euro, key: "savings" },
  { icon: Shield, key: "reliability" },
  { icon: Wrench, key: "service" },
  { icon: Award, key: "certification" },
  { icon: Truck, key: "delivery" },
  { icon: Headphones, key: "consultation" },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const Features = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-24 md:py-32 relative overflow-hidden">
      <div className="absolute top-1/2 right-0 translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-primary/5 blur-[100px]" />
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <m.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={optimizedViewport} transition={{ duration: 0.6 }} className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-sm font-medium text-primary mb-4 block">{t("features.badge")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold mb-6">
            {t("features.title")} <span className="text-gradient">{t("features.titleHighlight")}</span> {t("features.titleEnd")}
          </h2>
          <p className="text-muted-foreground text-lg">{t("features.subtitle")}</p>
        </m.div>

        <m.div variants={containerVariants} initial="hidden" animate="visible" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featureKeys.map((feature) => (
            <m.div key={feature.key} variants={itemVariants} className="group p-6 rounded-2xl bg-card-gradient border border-border hover:border-primary/30 transition-all duration-300 hover:shadow-lg hover:shadow-primary/5">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                <feature.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="font-heading text-xl font-semibold mb-2">{t(`features.items.${feature.key}.title`)}</h3>
              <p className="text-muted-foreground">{t(`features.items.${feature.key}.description`)}</p>
            </m.div>
          ))}
        </m.div>
      </div>
    </section>
  );
};

export default Features;
